/*
 * @Author: cw
 * @Date: 2021-11-09 10:49:25
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-18 16:07:11
 * @Description:
 */
import axios from 'axios'
import { Notification } from 'element-ui';
import {proxyLogout} from "@/utils/config"
// import {Message} from 'element-ui' // 项目用的element ui
// import router from '../router'

// let baseUrl = 'http://139.198.21.233:9040/';

// if (process.env.NODE_ENV === 'development') {
// 	baseUrl = 'http://139.198.21.233:9040/'; //fwq
//     //添加代理头  不需要可以注释
//     // baseUrl = 'api/'
//     // baseUrl = ''
// } else if (process.env.NODE_ENV === 'production') {
// 	baseUrl = 'http://139.198.21.233:9040/';
// }



// axios.defaults.baseURL = baseUrl;

// 请求超时时间
axios.defaults.timeout = 1000000;

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

axios.defaults.withCredentials = true;


// 请求拦截器
axios.interceptors.request.use(
    config => {
        if(sessionStorage['Access-Token']) {
            config.headers[ 'X-Access-Token' ] = sessionStorage['Access-Token'];
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
)

// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 接收后台参数状态
        const res = response.data;
        if (res.features) {
            return res
        }
        if(response.status===200){
            //token有问题的
            if(['2008'].includes(res.code)){
                sessionStorage.removeItem('userInfo')
                sessionStorage.removeItem('Access-Token')
                Notification({
                    title: '警告',
                    message: '此用户是集成平台用户,不能直接登录！',
                    type: 'warning'
                })
                let sevice = "http://" + window.location.host + '/';
                window.location.href = proxyLogout + "cas/logout" + '?service=' + encodeURIComponent(sevice)
                return Promise.reject(
                    new Error('token有bug')
                );
            }
            //token有问题的
            if(['2007'].includes(res.code)){
                sessionStorage.removeItem('userInfo')
                sessionStorage.removeItem('Access-Token')
                Notification({
                    title: '警告',
                    message: '该用户账号状态异常，请联系管理员！',
                    type: 'warning'
                })
                let sevice = "http://" + window.location.host + '/';
                window.location.href = proxyLogout + "cas/logout" + '?service=' + encodeURIComponent(sevice)
                return Promise.reject(
                    new Error('token有bug')
                );
            }
            //token有问题的
            if(['2002','2003','2004','2006'].includes(res.code)){
                sessionStorage.removeItem('userInfo')
                sessionStorage.removeItem('Access-Token')
                axios.get('config/AllUrl.json').then(resU => {
                    if (resU) {
                        let sevice = "http://" + window.location.host + '/';
                        window.location.href = resU.loginHeader + '?service=' + encodeURIComponent(sevice)
                    }
                })
                return Promise.reject(
                    new Error('token有bug')
                );
            }
            if(res.code==='100000'){
                let message = (res.error && res.error.message) || res.message || res.msg || '未知错误';
                // Message({
                //     message,
                //     type: 'error',
                //     duration: 4 * 1000
                // });
                return Promise.reject(
                    new Error(message)
                );
            }else{
                return res;
            }

        }else{
            let message = (res.error && res.error.message) || res.message || res.msg || '未知错误';
            // Message({
            //     message,
            //     type: 'error',
            //     duration: 4 * 1000
            // });
            return Promise.reject(
                new Error(message)
            );
        }
        //取消这个
        // if(res.code == '000000' || !res.code ||res.code == 20000 || res.status == 200 || res.success || res.ErrorCode == 20000) {
        //     return res;
        // }else {
        //     let message = (res.error && res.error.message) || res.message || res.msg || '未知错误';
        //     Message({
        //         message,
        //         type: 'error',
        //         duration: 5 * 1000
        //     });
        //     console.log('拦截器打印错误:', res);
        //     // 这里可以设置后台返回状态码是500或者是其他,然后重定向跳转
        //     // if(res.ErrorCode == 500) {
        //     //     router.push('/login')
        //     // }
        //     return Promise.reject(
        //         new Error(res.message || (res.error &&res.error.message) || '未知错误')
        //     );
        // }
    },
    error => {
        console.log('服务器错误信息:', error);
        if(error.response) {
            // error.response有错误信息,是接口错误,不是取消请求
            // 获取错误码,弹出提示信息,reject()
            let code = error.response.status;
            if(code == 401) {
                // router.push('/login');
                return Promise.reject(
                    new Error('登录过期,请重新登录')
                );
            }
            return Promise.reject(error.message);
        }else {
            // 是取消请求
            // 直接reject
            return Promise.reject(error.message);
        }
    }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err)
			})
	});
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			})
	});
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function put(url, params) {
    return new Promise((resolve, reject) => {
      axios.put(url, params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  
  /**
   * delete方法，对应delete请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
   export function deletes(url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(url,{
        params
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
